import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaHardHat, FaClipboardCheck, FaShieldAlt, FaChartLine, 
  FaUserTie, FaHandshake, FaArrowRight, FaCheckCircle, FaBuilding 
} from 'react-icons/fa';


// --- IMPORTS ---
import styles from './LandingPage.module.css'; // Your existing styles
import devHeroImage from '../../assets/images/business_hero.jpg'; 
import dashboardImage from '../../assets/images/img_ai_project_man.jpg';
import renoTradiesImage from "../../assets/images/img_b2b_networking.jpg";

import './DevelopersGrowthPageNew.css';

// --- SHARED COMPONENTS ---
import Header from './components/Header';
import Footer from './components/Footer';
import SocialProofEngine from '../../components/SocialProof/SocialProofEngine';
import AvailableJobs from '../../components/LiveJobs/AvailableJobs';
import SearchFormComponent from "../../pages/Dashboards/SearchFormComponent";
import AiSearchAssistant from "../../components/AiSearchAssistant/AiSearchAssistant";

import AppDownloadSection from './components/AppDownloadSection'; 
import TestimonialsSection from './components/TestimonialsSection'; 
import FinalCtaSection from './components/FinalCtaSection'; 

// --- SCROLL HELPER ---
const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) element.scrollIntoView({ behavior: 'smooth' });
};

// --- 1. HERO SECTION (Updated with Search Pill) ---
const DeveloperHero = () => {
  return (
    <section 
      className="bs-hero-section" 
      style={{ 
        backgroundImage: `linear-gradient(rgba(5, 21, 52, 0.9), rgba(5, 21, 52, 0.8)), url(${devHeroImage})`,
      }}
    >
      <div className="bs-container">
        <div className="bs-hero-content" style={{textAlign: 'center', margin: '0 auto'}}>
          
          <div className="bs-rating-badge" style={{justifyContent: 'center'}}>
            <span className="bs-stars">★★★★★</span>
            <span>TRUSTED BY HUNDREDS OF DEVELOPERS</span>
          </div>
          
          <h1 className="bs-hero-title">
            COMPLETE YOUR PROJECT WITH AN <br/> 
            <span className="bs-text-gold-gradient">ON-DEMAND WORKFORCE</span>
          </h1>
          
          <p className="bs-hero-subtitle" style={{margin: '0 auto 40px auto'}}>
            Stop the endless search for reliable businesses. 
            Search our exclusive network of vetted building professionals ready to quote.
          </p>

          {/* --- REPLACED WITH SEARCH FORM COMPONENT --- */}
          {/* This works because Developers "Search" for trades, they don't "List" themselves as trades */}
          <div className={styles.heroSearchWrapper}>
             <SearchFormComponent className={styles.landingPageSearchForm} />
          </div>

          <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '14px', marginTop: '20px'}}>
            Popular: Concreters, Surveyors, Electricians, Demolition
          </p>

        </div>
      </div>
    </section>
  );
};

// --- 2. PAIN POINTS (New Section) ---
const PainPoints = () => {
    return (
        <section style={{padding: '60px 0', background: '#fff'}}>
            <div className="bs-container" style={{textAlign: 'center'}}>
                <h2 style={{color: '#0a1f44', marginBottom: '40px', fontSize: '32px', fontWeight: '800'}}>
                    DELAYS COST YOU <span style={{color: '#d32f2f'}}>MONEY.</span>
                </h2>
                <div className="dev-pain-grid">
                    <div className="dev-pain-card">
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>The Flake Factor</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Trades that don't show up kill your timeline and push back your handover date.</p>
                    </div>
                    <div className="dev-pain-card">
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>Compliance Risk</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Using uninsured "cowboys" exposes your entire development to massive liability.</p>
                    </div>
                    <div className="dev-pain-card">
                        <h3 style={{color: '#c62828', fontSize: '18px', fontWeight: '700', marginBottom: '10px'}}>Price Gouging</h3>
                        <p style={{fontSize: '14px', color: '#555'}}>Last-minute hiring often means paying a premium just to get the job done.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

// --- 3. B2B SUBCONTRACTING ---
const SubcontractingSection = () => {
  return (
    <section className="bs-connect-section" style={{paddingTop: '60px', paddingBottom: '60px'}}>
      <div className="bs-container">
        <div className="bs-connect-grid" style={{alignItems: 'center'}}>
          
          <div className="bs-connect-content-col">
            <h2 className="bs-connect-title">
              BUILD YOUR <br />
              <span className="bs-font-thin">B2B NETWORK</span>
            </h2>
            <p className="bs-connect-desc">
              You aren't just a owner; you are a business. Build Start allows you to 
              <strong> create projects and contract work</strong> to other verified specialists. 
              Fill labour gaps instantly and keep your site moving.
            </p>
            <ul style={{listStyle: 'none', padding: 0, marginBottom: '30px', color: 'rgba(255,255,255,0.9)'}}>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Direct Professional & Trade Search
                </li>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Manage Multiple Sites from One Dashboard
                </li>
                <li style={{marginBottom: '10px', display:'flex', alignItems:'center', gap:'10px'}}>
                    <FaCheckCircle color="#4ade80"/> Rate & Review Businesses
                </li>
            </ul>
            <Link to="/select-role" className="bs-btn-pill-primary">
              Find Building Professionals
            </Link>
          </div>

            <div className="bs-connect-image-col" style={{justifyContent: 'center'}}>
            <img 
              src={renoTradiesImage} 
              alt="Plenty of tradies" 
              style={{
                width: '100%',
                maxWidth: '450px',        /* Limits the size */
                borderRadius: '16px',     /* Rounded corners */
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)', /* Pop-out shadow */
                objectFit: 'cover',
                height: 'auto'
              }} 
            />
          </div>

        </div>
      </div>
    </section>
  );
};

// --- 4. RISK MITIGATION (Reusing your section, styled better) ---
const RiskMitigation = () => {
  return (
    <section style={{padding: '80px 0', background: '#f8f9fa'}}>
      <div className="bs-container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{color: '#0a1f44', fontSize: '36px', fontWeight: '800', textTransform: 'uppercase'}}>
             Eliminate Site Risk
          </h2>
          <p style={{color: '#666', fontSize: '18px', maxWidth: '700px', margin: '0 auto'}}>
            One uninsured contractor can shut down a site. 
            Our <strong>Vetting Gauntlet</strong> ensures compliance before they step on your property.
          </p>
        </div>

        <div className="dev-risk-grid">
          {[
            { icon: FaShieldAlt, title: "License Check", desc: "Real-time government database verification." },
            { icon: FaClipboardCheck, title: "Insurance", desc: "Automated tracking for Public Liability." },
            { icon: FaUserTie, title: "Reputation", desc: "3-Star minimum rating requirement." },
            { icon: FaChartLine, title: "Monitoring", desc: "Continuous performance checks." }
          ].map((item, i) => (
            <div key={i} className="dev-risk-card">
                <div style={{width: '60px', height: '60px', background: '#e0f2fe', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto'}}>
                    <item.icon size={28} color="#0066ff" />
                </div>
                <h3 style={{fontSize: '18px', fontWeight: '700', color: '#0a1f44', marginBottom: '10px'}}>{item.title}</h3>
                <p style={{fontSize: '14px', color: '#666', lineHeight: '1.5'}}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// --- 5. AI PROJECT SECTION ---
const AiProjectSection = () => {
    // Reusing the style from your previous code, but ensuring class consistency
  return (
    <section className="dev-ai-section" style={{padding: '80px 0', background: '#fff'}}>
      <div className="bs-container-grid dev-ai-grid">

          <div style={{position: 'relative'}}>
             <img src={dashboardImage} alt="Dashboard" style={{width: '100%', borderRadius: '16px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)'}} />
             {/* Floating Badge */}
             <div className="dev-ai-badge" style={{position: 'absolute', bottom: '30px', left: '-20px', background: 'white', padding: '15px 25px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', gap: '15px'}}>
                <div style={{background: '#dcfce7', padding: '10px', borderRadius: '8px'}}><FaCheckCircle color="#16a34a"/></div>
                <div>
                    <div style={{fontWeight: '700', color: '#333'}}>Scope Generated</div>
                    <div style={{fontSize: '12px', color: '#666'}}>AI saved 4 hours</div>
                </div>
             </div>
          </div>

          <div className="bs-content-col">
            <h2 style={{fontSize: '42px', fontWeight: '800', color: '#0a1f44', marginBottom: '20px', lineHeight: '1.1'}}>
              RUN RENOVATIONS ON <br/>
              <span style={{color: '#0066ff'}}>AUTOPILOT</span>
            </h2>
            <p style={{fontSize: '16px', color: '#555', marginBottom: '30px', lineHeight: '1.6'}}>
              Flipping a house? Use our <strong>AI Project Templates</strong> (e.g., "Cosmetic Kitchen Refresh")
              to automatically generate tasks, stages, and timelines.
              Drag and drop tasks and invite trades directly to specific stages.
            </p>
            <Link to="/select-role" className="bs-btn-primary" style={{backgroundColor: '#0a1f44'}}>
                Try AI Tools Free
            </Link>
          </div>
      </div>
    </section>
  );
};


// --- 6. SIMPLE PRICING (Single Tier / Free) ---
const SimpleDeveloperPricing = () => {
    return (
        <section id="partnership-plans" style={{padding: '80px 0', background: '#0a1f44', color: 'white', textAlign: 'center'}}>
            <div className="bs-container">
                {/* Updated Headlines to focus on "Access" rather than "Choice" */}
                <h2 style={{fontSize: '36px', fontWeight: '800', marginBottom: '15px'}}>Everything You Need to Build</h2>
                <p style={{marginBottom: '50px', fontSize: '18px', opacity: 0.8, maxWidth: '600px', margin: '0 auto 50px auto'}}>
                    Join the fastest growing network of Developers and Renovators. <br/>
                    No credit card required. No hidden fees.
                </p>
                
                {/* Centered Single Card Layout */}
                <div style={{maxWidth: '700px', margin: '0 auto'}}>
                    
                    <div style={{
                        background: 'white', 
                        color: '#333', 
                        padding: '50px', 
                        borderRadius: '20px', 
                        textAlign: 'left',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.3)', // Added shadow for depth
                        position: 'relative'
                    }}>
                        {/* Optional Badge to replace "Recommended" */}
                        <div style={{
                            position: 'absolute', 
                            top: '-15px', 
                            right: '50%', 
                            transform: 'translateX(50%)', // Center the badge
                            background: '#00d084', // Green for "Go/Free"
                            color: '#0a1f44', 
                            padding: '8px 20px', 
                            borderRadius: '20px', 
                            fontSize: '14px', 
                            fontWeight: '800',
                            letterSpacing: '1px',
                            boxShadow: '0 4px 10px rgba(0,208,132,0.4)'
                        }}>
                            100% FREE ACCESS
                        </div>

                        <div style={{textAlign: 'center', marginBottom: '30px'}}>
                            <h3 style={{fontSize: '28px', fontWeight: '800', color: '#0a1f44'}}>Developer All-Access</h3>
                            <div style={{fontSize: '48px', fontWeight: '800', color: '#0066ff', margin: '10px 0'}}>
                                $0 <span style={{fontSize:'18px', color:'#666', fontWeight:'500'}}>/ for a limited time</span>
                            </div>
                            <p style={{color: '#666'}}>Get full access to our entire suite of tools and trades.</p>
                        </div>

                        {/* Combined Feature List - using 2 columns for the list if width permits, or just a nice single list */}
                        <div style={{background: '#f8f9fa', borderRadius: '12px', padding: '30px', marginBottom: '30px'}}>
                            <ul style={{
                                listStyle: 'none', 
                                padding: 0, 
                                margin: 0, 
                                display: 'grid', 
                                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', // Auto-grid for responsiveness
                                gap: '15px'
                            }}>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> Post Unlimited Jobs</li>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> Search Verified Trades</li>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> AI Project Management</li>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> Smart Trade Matching</li>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> Instant Job Templates</li>
                                <li style={{display:'flex', gap:'10px', alignItems:'center'}}><FaCheckCircle color="#0066ff"/> Dedicated Community Support</li>
                            </ul>
                        </div>

                        {/* Button is now Primary (Blue) because it's the main action */}
                        <div style={{textAlign: 'center'}}>
                            <Link to="/register/developer" className="bs-btn-pricing-primary" style={{
                                display: 'inline-block',
                                background: '#0066ff',
                                color: 'white',
                                padding: '15px 40px',
                                borderRadius: '50px',
                                textDecoration: 'none',
                                fontWeight: '700',
                                fontSize: '18px',
                                width: '100%',
                                maxWidth: '300px',
                                boxShadow: '0 10px 20px rgba(0, 102, 255, 0.2)'
                            }}>
                                Get Started for Free
                            </Link>
                            <p style={{marginTop: '15px', fontSize: '14px', color: '#888'}}>No credit card needed • Cancel anytime</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}



// --- MAIN PAGE COMPONENT ---
const DevelopersGrowthPageNew = () => {
  return (
    <div className="developer-landing-page">
      <Header />
      
      {/* 1. Hero with Search Pill */}
      <DeveloperHero />
      
      {/* 2. Social Proof */}
      <SocialProofEngine />

      {/* 3. Pain Points (Why use us?) */}
      <PainPoints />

      {/* 4. Subcontracting Feature */}
      <SubcontractingSection />

      {/* 6. Vetting / Trust */}
      <RiskMitigation />

      {/* 7. Live Job Activity */}
      <section style={{padding: '80px 0', background: '#f7f9fa'}}>
         <AvailableJobs limit={3} />
      </section>

      {/* 5. AI Features */}
      <AiProjectSection />





      {/* 8. Simplified Plans */}
      <SimpleDeveloperPricing />


      <AppDownloadSection />

      <TestimonialsSection />


      <FinalCtaSection 
        title="READY TO BUILD YOUR " 
        highlighttext="EMPIRE?" 
        subtitle="Join thousands of professionals building faster, cheaper, and safer on Build Start. Find businesses by profession, trade, location and more." 
      />


      <Footer />

      <AiSearchAssistant />
    </div>
  );
};

export default DevelopersGrowthPageNew;